import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-asphome',
  templateUrl: './asphome.component.html',
  styleUrls: ['./asphome.component.scss']
})
export class AsphomeComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Bachelors Degree in Pharmacy at ARNI School of Pharmacy');
        this.meta.updateTag({
            name: 'description',
            content: `Pursue a bachelors degree in pharmacy at ARNI School of Pharmacy. Equip yourself with essential skills and knowledge for a successful career in the pharmaceutical field.`
        });
    }

}
